"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notEmpty = void 0;
function notEmpty(value) {
    if (value === null || value === undefined)
        return false;
    return true;
}
exports.notEmpty = notEmpty;
//# sourceMappingURL=index.js.map